module.exports = __webpack_public_path__ + "img/ej-01.26a22b82.png";